import { createFileRoute } from '@tanstack/react-router';
import { TopUpPage } from '../components/pages/TopUpPage/TopUpPage';
import { z } from 'zod/mini';

const searchSchema = z.object({
  accountId: z.optional(z.string()),
});

export const Route = createFileRoute('/account/topup')({
  component: TopUpPage,
  validateSearch: searchSchema.parse,
});
